<script setup lang="ts">
/**
 * Prompt shown on the offer page until the visitor confirms dates and travellers.
 *
 * The `ibe.offer.complete-params-prompt` translation is CMS-authored and may contain
 * block HTML (`<p>`, `<br>`, lists, links, …), sanitized via `$tHtmlBlock`.
 */
import BaseAlert from '@/components/ui/BaseAlert.vue';
import I18nHtml from '@/components/ui/I18nHtml.vue';
</script>

<template>
  <BaseAlert type="success" icon="icon-info">
    <I18nHtml
      block
      tag="div"
      class="complete-params-content"
      key-name="ibe.offer.complete-params-prompt"
      fallback="Please complete your search parameters to view all available offers"
    />
  </BaseAlert>
</template>

<style scoped>
.complete-params-content :deep(p),
.complete-params-content :deep(ul),
.complete-params-content :deep(ol),
.complete-params-content :deep(blockquote),
.complete-params-content :deep(h1),
.complete-params-content :deep(h2),
.complete-params-content :deep(h3),
.complete-params-content :deep(h4),
.complete-params-content :deep(h5),
.complete-params-content :deep(h6) {
  margin-bottom: 0.5rem;
}

.complete-params-content :deep(h1),
.complete-params-content :deep(h2),
.complete-params-content :deep(h3),
.complete-params-content :deep(h4),
.complete-params-content :deep(h5),
.complete-params-content :deep(h6),
.complete-params-content :deep(strong),
.complete-params-content :deep(b) {
  font-weight: 600;
}

.complete-params-content :deep(ul),
.complete-params-content :deep(ol) {
  padding-left: 1.25rem;
  list-style: disc;
}

.complete-params-content :deep(ol) {
  list-style: decimal;
}

.complete-params-content :deep(li + li) {
  margin-top: 0.25rem;
}

.complete-params-content :deep(small) {
  font-size: 0.75rem;
}

.complete-params-content :deep(a) {
  color: inherit;
  text-decoration: underline;
}

.complete-params-content :deep(a:hover) {
  text-decoration: none;
}

.complete-params-content :deep(> *:last-child) {
  margin-bottom: 0;
}
</style>
